import React, { memo } from 'react';
import { Input, Label } from 'reactstrap';

const SwitchSelect = memo(({ label,name,checked,handleToggleChange, padding, disabled }) => {
    return (
        <div className='me-3'>
            <Label className="form-check-label" htmlFor={name}>{label}</Label>
            <div className={`form-check form-switch form-switch-sm  ${padding != undefined ? 'pt-2' : ''}`}>
                <Input className="form-check-input" name={name} type="checkbox" role="switch" checked={checked} onChange={handleToggleChange} disabled={disabled}/>
            </div>
        </div>

    )
})

export default SwitchSelect